// import AppBar from "@mui/material/AppBar";
import React, { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import Box from "@mui/material/Box";
import { Chip } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid2";
import Divider from "@mui/material/Divider";
import decimals from "../shared/images/decimals.png";
import {
  SubmitButton,
  HintsButton,
  SolutionButton,
  NextButton,
  VideoList,
} from "./style";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { Resource, Topic } from "../types";
import SolutionBox from "../solutions";
import HintsBox from "../hints";

import IconButton from "@mui/material/IconButton";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";

import FormControl from "@mui/material/FormControl";
import ClearIcon from "@mui/icons-material/Clear";
import Markdown from "react-markdown";

import { questions } from "../shared/mock";
import { useFetcher } from "react-router-dom";

type QuestionBoxProps = {
  levelId: string;
  subjectId: string;
  topic: Topic;

  disableSubmit: boolean;
  reset: Function;
};

const get_question = gql`
  query GetQuestion($levelId: ID!, $subjectId: ID!, $topicId: ID) {
    getQuestion(levelId: $levelId, subjectId: $subjectId, topicId: $topicId) {
      id
      answer
      content
      difficulty
      hints {
        content
      }
      solution {
        content
      }
      images {
        imgUrl
      }
      activityTips {
        content
      }
    }
  }
`;

const QuestionBox = ({
  levelId,
  subjectId,

  disableSubmit,
  topic,

  reset,
}: QuestionBoxProps) => {
  console.log("levelId", levelId);
  console.log("subjectId", subjectId);
  console.log("topicId", topic);

  const { loading, error, data, refetch } = useQuery(get_question, {
    variables: {
      levelId: levelId,
      subjectId: subjectId,
      topicId: topic?.name.toLowerCase(),
    },
  });

  // if (loading) console.log(loading);
  // if (error) console.log(error);
  if (data) console.log("Question data", data);

  const [showSolution, setShowSolution] = useState(false);
  const [showHints, setShowHints] = useState(false);
  const [hintId, setHintId] = useState(0);
  const [answer, setAnswer] = useState<number | string>("");
  const [showCorrectAnsMsg, setShowCorrectAnsMsg] = useState(false);
  const [showIncorrectAnsMsg, setShowIncorrectAnsMsg] = useState(false);
  const [showHintsButton, setShowHintsButton] = useState(true);

  const incrementHintId = () => {
    if (data?.getQuestion?.hints && data?.getQuestion?.hints.length > hintId) {
      setHintId(hintId + 1);
    }
  };

  const handleHints = () => {
    incrementHintId();
    setShowHints(true);
    setShowSolution(false);
  };

  const handleClear = () => {
    setAnswer("");
    setShowCorrectAnsMsg(false);
    setShowIncorrectAnsMsg(false);
    setShowSolution(false);
    setShowHints(false);
  };

  const handleShowSolution = () => {
    setShowSolution(true);
    setShowHints(false);
  };

  const handleNext = () => {
    setShowCorrectAnsMsg(false);
    setShowIncorrectAnsMsg(false);
    setShowSolution(false);
    setShowHints(false);
    setHintId(0);
    setAnswer("");
    reset();
    refetch();
  };

  const handleSubmit = () => {
    if (
      data?.getQuestion?.answer &&
      // Number(answer) === Number(data?.getQuestion?.answer)
      answer === data?.getQuestion?.answer
    ) {
      console.log("Your answer is correct!");

      setShowCorrectAnsMsg(true);
      setShowIncorrectAnsMsg(false);
    } else {
      console.log("Your answer is incorrect");
      setShowHintsButton(true);
      setShowIncorrectAnsMsg(true);
      setShowCorrectAnsMsg(false);
    }

    setShowHints(false);
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,

        maxWidth: "80%",
      }}
    >
      <Divider>
        <Chip
          label={topic?.name}
          size="small"
          style={{ backgroundColor: "#000000", color: "#fff", padding: "15px" }}
        />
      </Divider>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6, md: 8 }}>
          <Box style={{ margin: "30px" }}>
            <Card sx={{ maxHeight: 645, overflowY: "scroll" }}>
              <CardActionArea>
                <CardMedia
                // component="img"
                // height="340"
                // image={
                //   data?.getQuestion?.images[0]?.imgUrl
                //     ? data?.getQuestion?.images[0]?.imgUrl
                //     : decimals
                // }
                // alt="no-image-available"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h3"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                  >
                    Question
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ color: "#000000", fontSize: "1.2rem" }}
                  >
                    {data?.getQuestion?.content ? (
                      <Markdown>{data?.getQuestion?.content}</Markdown>
                    ) : (
                      "No questions available"
                    )}
                  </Typography>
                  <Divider
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  />
                  <Typography gutterBottom variant="h5" component="div">
                    Activity Tips:
                  </Typography>
                  <List>
                    {data?.getQuestion?.activityTips &&
                      data?.getQuestion?.activityTips.map(
                        (activityTip: { content: string }) => {
                          return (
                            // <ListItem>
                            <Typography
                              variant="body1"
                              sx={{ color: "#000000", fontSize: "1.2rem" }}
                            >
                              {activityTip.content ? (
                                <Markdown>{activityTip.content}</Markdown>
                              ) : (
                                "No tips available"
                              )}
                            </Typography>
                            // </ListItem>
                          );
                        }
                      )}
                  </List>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
          <Box style={{ margin: "30px" }}>
            <Typography variant="h5" gutterBottom>
              Answer:
            </Typography>

            <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                Enter Answer
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-answer"
                type="text"
                value={answer}
                onChange={(e) => {
                  e.target.value && setAnswer(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => handleClear()} edge="end">
                      {<ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Answer"
              />
            </FormControl>
          </Box>

          {showCorrectAnsMsg && (
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              Your answer is correct!
            </Alert>
          )}

          {showIncorrectAnsMsg && (
            <Alert severity="error">Yor answer is incorrect. </Alert>
          )}

          {showSolution && (
            <SolutionBox solution={data?.getQuestion?.solution} />
          )}
          {showHints && (
            <HintsBox id={hintId} hints={data?.getQuestion?.hints} />
          )}
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <Box style={{ margin: "30px" }}>
            <Typography variant="h5" gutterBottom>
              Learn Concepts:
            </Typography>
            <VideoList>
              {topic?.resources?.map(
                ({ embedId, title, description }: Resource) => {
                  return (
                    <ListItem>
                      <Card sx={{ display: "flex" }}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <CardContent sx={{ flex: "1 0 auto" }}>
                            <Typography component="div" variant="body1">
                              {title}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              component="div"
                              sx={{ color: "text.secondary" }}
                            >
                              {description}
                            </Typography>
                          </CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              pl: 1,
                              pb: 1,
                            }}
                          ></Box>
                        </Box>

                        <CardMedia sx={{ width: 285 }}>
                          <iframe
                            src={`https://www.youtube.com/embed/${embedId}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded youtube"
                          />
                        </CardMedia>
                      </Card>
                    </ListItem>
                  );
                }
              )}
            </VideoList>
          </Box>
        </Grid>
      </Grid>

      <Divider />
      <Grid container sx={{ flexGrow: 1, margin: "20px" }}>
        <Grid size={{ xs: 4, md: 2 }} offset={{ md: "auto" }}>
          {data?.getQuestion?.hints &&
          data?.getQuestion?.hints.length > hintId &&
          showHintsButton ? (
            <HintsButton variant="text" onClick={handleHints}>
              Show Hints
            </HintsButton>
          ) : (
            <SolutionButton variant="text" onClick={handleShowSolution}>
              Show Solution
            </SolutionButton>
          )}
        </Grid>
        <Grid>
          <SubmitButton
            variant="contained"
            disabled={disableSubmit}
            onClick={handleSubmit}
          >
            I got this!
          </SubmitButton>
          <NextButton variant="contained" onClick={handleNext}>
            Next
          </NextButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuestionBox;
